import * as actionType from './tpvAction';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';

const config = JSON.parse(Config);

const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}

export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})

export const GetTpvAuditList = (data) => ({
    type: actionType.GET_TPV_AUDIT_LIST,
    payload: data,
})
export const GetTpvNCList = (data) => ({
    type: actionType.GET_TPV_NC_LIST,
    payload: data,
})

export const isAuditorPlanList = (payload) => ({
    type: actionType.IS_AUDITOR_PLAN_LIST,
    payload
})

export const doGetTpvAllAuditPlan = (tpvAuditList) => {
    return tpvAuditList?.TpvAuditDetails.map((tpvAuditPlan)=> {
        return {
            editable: false,
            ...tpvAuditPlan,
            auditPlanId: tpvAuditPlan.auditDetailId,
            auditStartDate: tpvAuditPlan.auditDate,
            auditClosureDate: tpvAuditPlan.closureDate,
        }
    })
}

export const doGetFormattedTpvNcScore = (TpvNCScore, TpvLandLordNCScore) => {
    if(!TpvNCScore && !TpvLandLordNCScore) return [undefined, undefined]
    const initialValue = {
            alert_high: 0,
            alert_medium: 0,
            alert_low: 0,
    };
    let accumalatedScoreNCStatus = ["Open","Closed", "Total Observations", "Completion %"].map((ncStatus)=> {
        return {
            stats_first_column: ncStatus,
            key: ncStatus === "Open"
            ? "open_nc"
            : ncStatus === "Closed"
            ? "closed_nc"
            : ncStatus === "Total Observations"
            ? "total_observations"
            : ncStatus === "Completion %"
            ? "completion_percentage"
            : null,
            ...TpvNCScore?.reduce((scoreAccumulator, item) => {
                if(ncStatus === "Open"){
                    if(item.alertLevel === "HIGH" && item.auditorClosureUpdate == "OPEN"){
                        scoreAccumulator.alert_high += item.total;
                    } else if(item.alertLevel === "MEDIUM" && item.auditorClosureUpdate == "OPEN"){
                        scoreAccumulator.alert_medium += item.total;
                    } else if(item.alertLevel === "LOW" && item.auditorClosureUpdate == "OPEN"){
                        scoreAccumulator.alert_low += item.total;
                    }
                }else if(ncStatus === "Closed" && item.auditorClosureUpdate == "CLOSE") {
                    if(item.alertLevel === "HIGH" && item.auditorClosureUpdate == "CLOSE"){
                        scoreAccumulator.alert_high += item.total;
                    } else if(item.alertLevel === "MEDIUM" && item.auditorClosureUpdate == "CLOSE"){
                        scoreAccumulator.alert_medium += item.total;
                    } else if(item.alertLevel === "LOW" && item.auditorClosureUpdate == "CLOSE"){
                        scoreAccumulator.alert_low += item.total;
                    }
                }
                return scoreAccumulator;
            }, {...initialValue})
        }
    })
    //calculate the total & percentage
    const totalObservations = {
            ...accumalatedScoreNCStatus?.reduce((scoreAccumulator, item, currentIndex, array) => {
                if(item.stats_first_column === "Open" || item.stats_first_column === "Closed"){
                    scoreAccumulator.alert_high += item.alert_high
                    scoreAccumulator.alert_medium += item.alert_medium
                    scoreAccumulator.alert_low += item.alert_low
                }
                if(item.stats_first_column === "Closed"){
                    scoreAccumulator.closed_high += item.alert_high
                    scoreAccumulator.closed_medium += item.alert_medium
                    scoreAccumulator.closed_low += item.alert_low
                }
                if(currentIndex == array.length-1){ //last iteration
                    accumalatedScoreNCStatus = accumalatedScoreNCStatus?.map((item)=> {
                        if(item?.stats_first_column === "Completion %"){
                            let high = scoreAccumulator.alert_high!=0?(scoreAccumulator.closed_high/scoreAccumulator.alert_high)*100:0;
                            let medium = scoreAccumulator.alert_medium!=0?(scoreAccumulator.closed_medium/scoreAccumulator.alert_medium)*100:0;
                            let low = scoreAccumulator.alert_low!=0?(scoreAccumulator.closed_low/scoreAccumulator.alert_low)*100:0;
                            return {
                                ...item,
                                alert_high: Number.isNaN(Number(high.toFixed(2)))?0:Number(high.toFixed(2)),
                                alert_medium: Number.isNaN(Number(medium.toFixed(2)))?0:Number(medium.toFixed(2)),
                                alert_low: Number.isNaN(Number(low.toFixed(2)))?0:Number(low.toFixed(2)), 
                            }
                        }
                        return item;
                    })
                    delete scoreAccumulator.closed_high;
                    delete scoreAccumulator.closed_medium;
                    delete scoreAccumulator.closed_low;
                }
                return scoreAccumulator;
            }, {...initialValue, closed_high:0, closed_medium:0, closed_low:0})
    }
    //update total observations
    accumalatedScoreNCStatus = accumalatedScoreNCStatus.map((item)=> {
        if(item?.key === "total_observations")
            return {
                ...item,
                alert_high: totalObservations.alert_high,
                alert_medium: totalObservations.alert_medium,
                alert_low: totalObservations.alert_low,
            }
        return item
    })
    let landLordScore = [
        {
            landlord_first_column: "Open",
            key: "open_nc_landlord",
            land_lord: 0
        },
        {
            landlord_first_column: "Closed",
            key: "closed_nc_landlord",
            land_lord: 0
        },
        {
            landlord_first_column: "Scopes under Landlord",
            key: "scopes_landlord",
            land_lord: 0
        },
        {
            landlord_first_column: "Completion %",
            key: "completion_percentage_landlord",
            land_lord: 0
        },
    ]
    let temp = TpvLandLordNCScore?.map((score, index) => {
        return landLordScore.filter((formattedScore)=> {
            if(score.storeClosureUpdate == "CLOSE" && formattedScore.landlord_first_column == "Closed"){
                landLordScore[1] = {
                    ...formattedScore,
                    land_lord: score.total,
                }
                return;
            }
            if(score.storeClosureUpdate == "OPEN" && formattedScore.landlord_first_column == "Open"){
                landLordScore[0] = {
                    ...formattedScore,
                    land_lord: score.total,
                }
            }
            return;
        })
    }).flat();
    //udpate total score
    landLordScore[2]["land_lord"] = landLordScore[0]["land_lord"] + landLordScore[1]["land_lord"]
    //update the percentage
    landLordScore[3]["land_lord"] = landLordScore[2]["land_lord"]!=0?Number(((landLordScore[1]["land_lord"]/landLordScore[2]["land_lord"])*100)?.toFixed(2)):0
    return [accumalatedScoreNCStatus,landLordScore];
}

export const doGetFormattedTpvSelectData = (auditorList) => {
    let selectTpvData = auditorList?.AuditorList.map((auditorDetails) => {
        let storeArray = auditorDetails.storeId.split(',').map(item => parseInt(item, 10));
        let mappedProjectScopes =[...new Set(auditorDetails?.auditorContractMappingInfos?.map(item => item.projectScopesId).join(',').split(','))]
        return {
            auditorId : auditorDetails.id,
            auditorName : auditorDetails.auditorName,
            editable : false,
            projectScopes : mappedProjectScopes?.map((projectScopeId, index)=> {
                return {
                    id: projectScopeId,
                    value: auditorList.ProjectScopes.map((scope) => { if(scope.id == projectScopeId) return scope.name}).filter(item => item !=undefined)[0],
                    available: true 
                }
            }),
            auditorStatus : {
                value: auditorDetails.auditorStatus == "Active"?1:0,
                name: auditorDetails.auditorStatus,
            },
            state: auditorDetails.auditorSupplyDetails.map((supplyDetails) => {
                return auditorList?.StateList.flatMap((state)=> {
                        if(state.codeId==supplyDetails.state)
                        return {
                            codeId: state.codeId,
                            codeValue: state.codeValue
                        }
                    }).filter((item) => item !=undefined) 
            }).flat(),
            city: auditorDetails.auditorSupplyDetails.map((supplyDetails) => {
                return auditorList?.CityList.flatMap((city)=> {
                        if(city.codeId==supplyDetails.city)
                        return {
                            codeId: city.codeId,
                            codeValue: city.codeValue
                        }
                    }).filter((item) => item !=undefined)
            }).flat(),
            store: auditorList?.StoreList.flatMap((store)=> {
                        if(Array.isArray(storeArray)&&storeArray.includes(store.storeId))
                        return {
                            codeId: store.storeId,
                            codeValue: store.storeName,
                            city: store.storeCity,
                            state: store.storeState
                        }
                    }).filter((item) => item !=undefined)
            }
    })
    return selectTpvData?.filter(data => data.store?.length) //eliminate length 0
}

export const getFormattedAllNcList = (ncList) => {
    if(!ncList) return;
    return ncList.map((nc)=> {
        return {
            ...nc,
            editable: false
        }
    });
}

/** Api calls */
export const doGetAllTpvAuditListnNCScore = () => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/fetchTPVDetails?alertLevel=&alertType=')
        .then((response) => {
            initialState.loading = false;
            if (response.status == 'Success') {
                const {
                    stateInfo: StateList,
                    cityInfo: CityList,
                    storeInfo: StoreList,
                    auditorDetail: AuditorList,
                    projectScopes: ProjectScopes,
                    tpvNCCountDetailsInfo: TpvNCScore,
                    tpvNCLandlordCountInfo: TpvLandLordNCScore,
                    tpvauditDetailsInfo: TpvAuditDetails,

                } = response;

                const TpvData = { StateList, CityList,StoreList, AuditorList, ProjectScopes, TpvNCScore, TpvAuditDetails, TpvLandLordNCScore}
                initialState.message = ''
                initialState.modalOpen=false;
                initialState.apiStatus = false;
                dispatch(GetTpvAuditList(TpvData))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response[0]?.Table1[0]?.status_msg;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}

export const doGetTpvNCDetailsGivenParams = (alertType, alertLevel) => {
    return ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/fetchTPVDetails?alertLevel='+alertLevel+'&alertType='+alertType)
        .then((response) => {
            if(response.status == 'Success')
                return Promise.resolve(response);
            else 
                return Promise.reject(response);
        })
        .catch((e) => {
            return Promise.reject(e)
        })
}

export const UpdateAuditPlan = (values) => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePut(
        config['api2'] +
        '/api/updateTPVAuditDetails', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result?.status
                initialState.modalOpen = true;
                initialState.apiStatus = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result?.errorMessage;
                initialState.apiStatus = false;
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.apiStatus = false;
            initialState.message = 'Something went wrong please try again after sometime';
            dispatch(apiCallStatus(initialState))
        })
}

export const CreateAuditPlan = (values) => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePost(
        config['api2'] +
        '/api/tpvAuditDetails', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result?.status
                initialState.modalOpen = true;
                initialState.apiStatus = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result?.errorMessage;
                initialState.apiStatus = false;
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.apiStatus = false;
            initialState.message = 'Something went wrong please try again after sometime';
            dispatch(apiCallStatus(initialState))
        })
}
export const doGetAllTpvNCList = () => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/viewNCDetail?auditorId=0')
        .then((response) => {
            initialState.loading = false;
            if (response.status == 'Success') {
                initialState.message = ''
                initialState.modalOpen=false;
                initialState.apiStatus = false;
                dispatch(GetTpvNCList(response?.tpvNcViewList))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response?.errorMessage;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}

export const fetchNCGivenAuditorId = (auditorId) => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleGet(
        config['api2'] +
        '/api/viewNCDetail?'+"auditorId="+auditorId)
        .then((response) => {
            initialState.loading = false;
            if (response.status == 'Success') {
                initialState.message = ''
                initialState.modalOpen=false;
                initialState.apiStatus = false;
                dispatch(GetTpvNCList(response?.tpvNcViewList))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.message = response?.errorMessage;
                initialState.modalOpen = true;
                dispatch(apiCallStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const CreateTpvNC = (values) => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimpleMultipartPost(
        config['api2'] +
        '/api/uploadNCDetail', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result?.status
                initialState.modalOpen = true;
                initialState.apiStatus = true;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result?.errorMessage;
                initialState.apiStatus = false;
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.apiStatus = false;
            initialState.message = 'Something went wrong please try again after sometime';
            dispatch(apiCallStatus(initialState))
        })
}
export const UpdateTpvNC = (values, orignialCopy) => async(dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SimplePut(
        config['api2'] +
        '/api/updateNCDetail', values)
        .then((result) => {
            initialState.loading = false;
            if (!result?.code?.includes("ERR")) {
                initialState.apiStatus=true;
                initialState.message = result?.status
                initialState.modalOpen = true;
                initialState.apiStatus = true;
                initialState.formattedNUpdateNC = values;
                dispatch(apiCallStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.message = result?.errorMessage;
                initialState.apiStatus = false;
                initialState.formattedNUpdateNC = orignialCopy;
                dispatch(apiCallStatus(initialState))  
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.apiStatus = false;
            initialState.message = 'Something went wrong please try again after sometime';
            initialState.formattedNUpdateNC = orignialCopy;
            dispatch(apiCallStatus(initialState))
        })
}
export const apiCallStatus = (data) => async(dispatch) => {
    dispatch(apiStatus(data))
}
export const AuditPlanList=(data)=>(dispatch)=>{
    dispatch(isAuditorPlanList(data))
}